
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pokal/finals",
      function () {
        return require("private-next-pages/pokal/finals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pokal/finals"])
      });
    }
  